import React from "react";
import { AvatarCustom } from "../../../components";
import { fromUnixToFormattedVisitdateStr } from "../../../utils/unix-timestamp";

interface IPastPlanCardProps {
    petId: string;
    petImage: string;
    petName: string;
    endDate: string;
    planName: string;

}
const PastPlanCard = ({ petId, petImage, petName, planName,
  endDate }: IPastPlanCardProps) => {
  return (
    <div className="border border-taupe-50 rounded-xl
    p-3 pb-4 w-full bg-white flex flex-col gap-3 shadow-md" key={petName}>
      <div className="flex gap-3 w-full items-center">
        <div className="">
          <AvatarCustom
            width={70}
            height={70}
            image={petImage}
            name={petName}
            isPlanOverdue={true}
            className="h-16"
          />
        </div>
        <div className="self-start">
          <div className="font-semibold">
            <p>
              {planName}
            </p>
          </div>
          <div className="text-sm text-justify">
            <p>{petName}</p>
            <p><span className="font-semibold text-sm">Plan Ended:</span>
                  &nbsp;{fromUnixToFormattedVisitdateStr(+endDate)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PastPlanCard;
